import moment from 'moment';
import React, { useState } from 'react';

export function FullHours({ full_hours = {} }) {
    const [isOpen, setIsOpen] = useState(false);

    const todayName = moment().format('ddd');
    const todayHour = full_hours[todayName] || "";

    return (
        <div className="group flex flex-col items-center border-t border-dashed border-t-gray-700 py-5">
            {/* Toggle Header */}
            <div
                className="w-full flex flex-row justify-between items-center cursor-pointer gap-3"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="flex flex-row items-center gap-3">
                    <img src="/assets/gym-facilities/time.png" className="h-6 w-6" alt="time" />
                    <p className="text-md md:text-lg text-white max-w-lg m-0">
                        {todayName}, {todayHour || 'Closed'}
                    </p>
                </div>
                <div
                    className={`transform transition-transform duration-300 text-2xl leading-none ${isOpen ? 'rotate-0' : '-rotate-180'}`}
                >
                    <img
                        className="w-5 h-5 transition-transform duration-300"
                        src="/assets/services/1/angle-down.png"
                        alt="angle-down"
                    />
                </div>
            </div>

            {/* Animated Collapsible Section */}
            <div className={`w-full flex flex-col justify-center items-start gap-3 pl-5 overflow-hidden transition-all duration-500 ease-in-out ${isOpen ? 'max-h-[500px] pt-3 mt-5 opacity-100 border-t border-dashed border-t-gray-700' : 'max-h-0 opacity-0'}`}
            >
                {Array.from({ length: 7 }).map((_, index) => {
                    const week_start = moment().startOf('week').add(index, 'd').format('ddd');
                    const value = full_hours?.[week_start] || null;
                    return (
                        <div className="flex flex-row items-center gap-3" key={index}>
                            <img src="/assets/gym-facilities/time.png" className="h-6 w-6 opacity-50" alt="time" />
                            <div
                                className={`flex text-sm md:text-md ${value ? 'text-gray-500' : 'text-red-600'} m-0`}
                            >
                                <div className="w-9 md:w-11">{week_start}</div>
                                <span className="mx-3">-</span>
                                <span>{value || 'Closed'}</span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
